"use client";
import { Moon, Sun } from "lucide-react";
import { useSettings } from "@/hooks/useSettings";

export function ThemeToggle() {
	const { theme, toggleTheme, mounted } = useSettings();

	if (!mounted) {
		return (
			<button className="p-2 rounded-full text-light-text hover:text-light-text/80 hover:bg-light-surface dark:text-dark-text dark:hover:text-dark-text/80 dark:hover:bg-dark-surface transition-all duration-200 ease-in-out">
				<Sun className="h-5 w-5" />
			</button>
		);
	}

	return (
		<button
			className="p-2 rounded-full text-light-text hover:text-light-text/80 hover:bg-light-surface dark:text-dark-text dark:hover:text-dark-text/80 dark:hover:bg-dark-surface transition-all duration-200 ease-in-out"
			onClick={toggleTheme}
		>
			{theme === "light" ? (
				<Moon className="h-5 w-5" />
			) : (
				<Sun className="h-5 w-5" />
			)}
			<span className="sr-only">Toggle theme</span>
		</button>
	);
}
